module.exports = __webpack_public_path__ + "static/media/arya_gandhi.04cd808a.jpg";